import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { MomentModule } from 'angular2-moment';
import { ConsultationProcessRoutingModule } from './consultation-process.routing';
import { SharedModule } from '../../shared/shared.module';
import { Component } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DatePickerModule} from '../../components/date-picker/date-picker.module';
import { DatePipe } from '@angular/common';

import { PatientDetailComponent } from './patient-detail/patient-detail.component';
import { MedicalConditionsComponent } from './medical-conditions/medical-conditions.component';
import { RecordPreviousVaccinesComponent } from './record-previous-vaccines/record-previous-vaccines.component';
import { SelectDiseaseComponent } from './select-disease/select-disease.component';
import { MedicalConditionPopupComponent } from './medical-conditions/new-condition-popup.component';
import { NewVaccinePopupComponent } from './record-previous-vaccines/new-vaccine-popup.component';
import { PrescribeVaccinationComponent } from './prescribe-vaccination/prescribe-vaccination.component';
import { NewDiseasePopupComponent } from './select-disease/new-disease-popup.component';
import { MenstrualPeriodComponent } from './medical-conditions/menstrual-period.component';
import { GroupRecommendedDiseaseComponent } from './group-recommended-disease/group-recommended-disease.component';
import { GroupRecommendedPrescriptionsComponent } from './group-recommended-prescriptions/group-recommended-prescriptions.component';

import { TripInformationComponent } from './trip-information/trip-information.component';
import { PopupSummaryTripInformationComponent } from './pop-up-summary-trip-information/pop-up-summary-trip-information.component';
import { NewTripInformationPopupComponent } from './trip-information/new-trip-information.component';
import { PickDateComponent } from './prescribe-vaccination/pick-date.component';
import { ConsultationProcessComponent } from './consultation-process.component';
import { SelectPrescriptionComponent } from './select-prescriptions/select-prescriptions.component';
import { LabTestComponent } from './lab-tests/lab-tests.component';
import { SaveConsultationComponent } from './save-consultation/save-consultation.component';
import { AdministerVaccineComponent } from './administer-vaccine/administer-vaccine.component';
import { ConfirmationLabTestComponent } from './confirmation-lab-tests/confirmation-lab-tests.component';
import { EditPrescriptionPopupComponent } from './select-prescriptions/edit-prescription-popup.component';
import { NewLabTestPopupComponent } from './confirmation-lab-tests/new-labtest-popup.component';
import { GroupRecommendedLabTestsComponent } from './group-recommended-lab-tests/group-recommended-lab-tests.component';
import { GroupRecommendedLabTestPopupComponent } from './group-recommended-lab-tests/group-recommeded-lab-tests-popup.component';
import { AdministerVaccinePopupComponent} from './administer-vaccine/administer-vaccine-popup.component';
import { MdAutocompleteModule, MdProgressSpinnerModule } from '@angular/material';
import { BaseConsultationComponent } from './base-consultation/base-consultation.component';
@NgModule({
    declarations: [
      BaseConsultationComponent,
      PatientDetailComponent,
      MedicalConditionsComponent,
      RecordPreviousVaccinesComponent,
      SelectDiseaseComponent,
      PrescribeVaccinationComponent,
      NewVaccinePopupComponent,
      MedicalConditionPopupComponent,
      NewDiseasePopupComponent,
      TripInformationComponent,
      PopupSummaryTripInformationComponent,
      NewTripInformationPopupComponent,
      PickDateComponent,
      ConsultationProcessComponent,
      MenstrualPeriodComponent,
      SelectPrescriptionComponent,
      LabTestComponent,
      SaveConsultationComponent,
      AdministerVaccineComponent,
      ConfirmationLabTestComponent,
      EditPrescriptionPopupComponent,
      NewLabTestPopupComponent,
      GroupRecommendedDiseaseComponent,
      GroupRecommendedPrescriptionsComponent,
      GroupRecommendedLabTestsComponent,
      GroupRecommendedLabTestPopupComponent,
      AdministerVaccinePopupComponent,
    ],
    imports: [
      SharedModule,
      MomentModule,
      DatePickerModule,
      ConsultationProcessRoutingModule,
      MdProgressSpinnerModule,
      MdAutocompleteModule
    ],
    entryComponents: [
      MedicalConditionPopupComponent,
      NewVaccinePopupComponent,
      TripInformationComponent,
      PopupSummaryTripInformationComponent,
      NewTripInformationPopupComponent,
      PickDateComponent,
      NewDiseasePopupComponent,
      ConsultationProcessComponent,
      MenstrualPeriodComponent,
      SelectPrescriptionComponent,
      LabTestComponent,
      SaveConsultationComponent,
      ConfirmationLabTestComponent,
      EditPrescriptionPopupComponent,
			NewLabTestPopupComponent,
      GroupRecommendedLabTestPopupComponent,
      AdministerVaccinePopupComponent
   ],
    providers: [{provide: 'currentStep', useValue: 0}, {provide: 'isGroup', useValue: false}],
    //providers: [],
    bootstrap: []
  })

  export class ConsultationProcessModule {
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/consultation-process.module.ts